module.exports = __webpack_public_path__ + "static/media/jadar-auto.fdc0fa95.jpg";